import { Box, ProgressBar } from '@primer/react';
import React, { useMemo } from 'react';
import { useDangKyAnHocSinh } from '../../hooks/useDangKyAnHocSinh';
import { useLiveCheckinDataContext } from './useLiveCheckInDataContext';
import { log } from 'node:console';

const SummaryData = () => {
    const { dangKyAnHocSinhs } = useLiveCheckinDataContext();
    const summaryData = useMemo(() => {
        let da_diem_danh = 0;
        let chua_diem_danh = 0;
        let dang_ky_khong_an = 0;
        dangKyAnHocSinhs.forEach(x => {
            if (x.gio_diem_danh) {
                da_diem_danh += 1;
            } else {
                chua_diem_danh += 1;
            }
            if (!x.is_dang_ky_an) {
                dang_ky_khong_an += 1;
            }
        })
        return {
            da_diem_danh,
            chua_diem_danh,
            dang_ky_khong_an,
            tong_so: da_diem_danh + chua_diem_danh
        }
    }, [dangKyAnHocSinhs])
    const percent = useMemo(() => {
        const tong_so = summaryData.chua_diem_danh + summaryData.da_diem_danh;
        // console.log({
        //     tong_so,
        //     chua_diem_danh: summaryData.chua_diem_danh
        // });

        if (tong_so > 0) {
            return Math.round((summaryData.da_diem_danh / tong_so) * 100);
        }
        return 0;
    }, [summaryData])
    return (
        <Box sx={{
            display: "grid",
            gap: 4
        }}>
            <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 2 }}>
                <Box sx={{
                    display: "grid", justifyItems: "center", backgroundColor: "success.subtle", color: "success.emphasis",
                    borderRadius: 2,
                    p: 2
                }}>
                    <Box>Đã điểm danh</Box>
                    <Box sx={{ fontWeight: 500, fontSize: 24 }}>
                        {summaryData.da_diem_danh}
                    </Box>
                </Box>
                <Box sx={{
                    display: "grid", justifyItems: "center", backgroundColor: "severe.muted", color: "severe.emphasis",
                    borderRadius: 2,
                    p: 2
                }}>
                    <Box>Chưa điểm danh</Box>
                    <Box sx={{ fontWeight: 500, fontSize: 24 }}>
                        {summaryData.chua_diem_danh}
                    </Box>
                </Box>
                <Box sx={{
                    display: "grid", justifyItems: "center", backgroundColor: "danger.muted", color: "danger.emphasis",
                    borderRadius: 2,
                    p: 2
                }}>
                    <Box>Đăng ký không ăn</Box>
                    <Box sx={{ fontWeight: 500, fontSize: 24 }}>
                        {summaryData.dang_ky_khong_an}

                    </Box>
                </Box>
            </Box>
            <Box sx={{
                display: "grid",
                gap: 2
            }}>
                <Box sx={{ display: "flex" }}>
                    <Box sx={{ color: "fg.muted", fontWeight: 600 }}>Tiến trình đã điểm danh</Box>
                    <Box sx={{ flex: 1, textAlign: "right" }}>
                        {summaryData.da_diem_danh}/ {summaryData.tong_so}
                    </Box>
                </Box>
                <ProgressBar progress={percent}
                    barSize="small"
                    aria-label="avg"
                    bg="success.emphasis"
                />
            </Box>
        </Box>
    );
};

export default SummaryData;